import { Matrix } from 'app/models/questions/Matrix'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { KanoComponent } from 'app/modules/survey/survey-viewer/survey-question/types/kano/kano.component'

export class Kano extends Matrix {
  getDisplayComponent(): QuestionComponent {
    return new QuestionComponent(KanoComponent, this)
  }
}
